export default __webpack_public_path__ + "static/B33-76f6f1009fabf74005a6174d0735f423.png";